exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap[data-v-35f18b76]{width:100%;position:relative}.item[data-v-35f18b76]{position:absolute;bottom:0;width:100px;left:calc(50% - 50px);font-size:30px}", ""]);

// exports
